
export function blockSupportScript() {
    document.addEventListener('DOMContentLoaded', function () {
        var $ = jQuery.noConflict ();

        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            var offsetSection = $('.support').offset().top;
            var video1 = $('#videoStart video')[0]
            var video2 = $('#nextVideo video')[0];
            var btn = $('#playNextVideo');
            if(scrollTop >= offsetSection){
                if(video1){
                    video1.play();
                }
            }
            if(btn){
                btn.click(function (){
                    $('#videoStart').hide()
                    $('#nextVideo').show()
                    video2.load()
                    video2.play()
                })
            }
        });
    })
}